export function buildImgURLFromAssetId(
  assetId: string,
  staticURL: string,
  typePath: string,
  sizeType: string
): string {
  const ext = assetId.split("_").pop();
  return `${staticURL + typePath + assetId + sizeType}.${ext}`;
}

export function buildImgURLFromLegacyAssetId(
  assetId: string,
  staticURL: string,
  typePath: string,
  sizeType: string
): string {
  const splitParts = assetId.split(".");
  const ext = splitParts.pop();
  return `${staticURL + typePath + splitParts.join(".") + sizeType}.${ext}`;
}

function getExt(filename: string): string {
  //mindbreaking shit!
  //https://stackoverflow.com/questions/190852/how-can-i-get-file-extensions-with-javascript/1203361#1203361
  return filename.substr((~-filename.lastIndexOf(".") >>> 0) + 2);
}

export function preLoader(originalImgURL: string): Promise<null> {
  return new Promise<null>((resolve, reject) => {
    const imgPreload: HTMLImageElement = new Image();
    imgPreload.onload = (): void => resolve();
    imgPreload.onerror = (): void => reject();
    imgPreload.src = originalImgURL;
  });
}

export function metaDataRender(metaData: any, staticURL: string): any {
  const scope: any = {};

  /** common to all video types, external, hosted, or third party */
  if (metaData.mediaType === "video") {
    scope.isVideo = true;
  }

  if (
    metaData.type === "external" ||
    metaData.type === "tenor" ||
    metaData.type === "pexels"
  ) {
    if (metaData.author) {
      scope.author = metaData.author;
    }

    if (metaData.type === "tenor") {
      scope.video = metaData.asset;

      const lastSegment = metaData.asset.split("/").pop();
      if (lastSegment.indexOf(".") === -1) {
        scope.ext = lastSegment;
      } else {
        scope.ext = lastSegment.split(".").pop();
      }
      scope.isTenor = true;
    } else if (metaData.type === "pexels") {
      scope.zoomImg = metaData.assetBig;
      scope.isPexels = true;
    } else if (metaData.type === "external" && metaData.mediaType === "video") {
      scope.ext = getExt(metaData.asset);
      scope.video = metaData.asset;
    }
    scope.img = metaData.asset;
    scope.isUpload = false;
    // log.info(scope.isVideo, scope.ext)
  } else if (metaData.type === "hosted") {
    scope.img = buildImgURLFromAssetId(
      metaData.asset,
      staticURL,
      "image_uploads/imgNode/",
      "_mid"
    );
    scope.zoomImg = buildImgURLFromAssetId(
      metaData.asset,
      staticURL,
      "image_uploads/imgNode/",
      "_zoom"
    );
    scope.isUpload = true;
  }
  return scope;
}

function querloUnescape(s: string): any {
  let ts = "",
    c = "";
  for (let i = 0; i < s.length; i++) {
    const t = s.substring(i, i + 2),
      t0 = t.charAt(0);
    if (t === "\\\\") {
      c = "\\";
      i++;
    } else if (t === "\\[") {
      c = "[";
      i++;
    } else if (t === "\\]") {
      c = "]";
      i++;
    } else if (t0 === "[") {
      c = "{";
    } else if (t0 === "]") {
      c = "}";
    } else {
      c = t0;
    }
    ts += c;
  }
  return JSON.parse(ts);
}

export function legacyRender(imgRawObj: any, staticURL: string): any {
  const scope: any = {};
  let url, imgObj;

  if (imgRawObj.img_url) {
    //check if the img_url is a string or an object
    if (imgRawObj.img_url.indexOf("[") === 0) {
      imgObj = querloUnescape(imgRawObj.img_url);
      if (imgObj.author) scope.author = imgObj.author;
      url = imgObj.img;

      if (imgObj.t === "tenor") {
        scope.isVideo = true;
        scope.video = url;
        const splits = url.split("/");
        scope.ext = splits[splits.length - 1];
      } else if (imgObj.t == "pexels") {
        scope.isPexels = true;
      }

      scope.zoomImg = imgObj.big;
      scope.img = imgObj.img;
    }

    scope.isUpload = false;
    // log.info(scope.isVideo, scope.ext)
  } else {
    scope.img = buildImgURLFromLegacyAssetId(
      imgRawObj.img,
      staticURL,
      "",
      "_mid"
    );
    scope.zoomImg = buildImgURLFromLegacyAssetId(
      imgRawObj.img,
      staticURL,
      "",
      "_zoom"
    );
    scope.isUpload = true;
  }

  return scope;
}
